module.exports = __webpack_public_path__ + "static/media/sidharth.5dff92b8.jpg";